var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('warn-page',[_vm._v("\n    "+_vm._s(_vm.$t('labels.page_not_founded'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }